/**
 * Free Jewelry Badge Manager
 * Shows/hides "GRATIS" badges on jewelry products based on cart total
 */

class FreeJewelryBadgeManager {
  constructor() {
    this.thresholdNormal = 70; // €70 threshold when no discount code
    this.thresholdWithCode = 63; // €63 threshold when discount code is active
    this.init();
  }

  init() {
    // Show/hide badges on page load
    this.updateBadges();

    // Listen for cart updates
    document.addEventListener('cart:update', () => this.updateBadges());
    document.addEventListener('cart:updated', () => this.updateBadges());
  }

  async updateBadges() {
    try {
      const cart = await this.fetchCart();
      const cartTotal = this.calculateCartTotal(cart);
      const hasCode = this.hasDiscountCode(cart);
      const activeThreshold = hasCode ? this.thresholdWithCode : this.thresholdNormal;
      const badges = document.querySelectorAll('[data-free-jewelry-badge]');

      badges.forEach(badge => {
        if (cartTotal >= activeThreshold) {
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      });

    } catch (error) {
      console.error('[Free Jewelry Badge] Error:', error);
    }
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    return await response.json();
  }

  hasDiscountCode(cart) {
    // Check if cart has any discount codes active
    // Shopify cart.discount_applications includes both automatic and code-based discounts
    if (!cart.discount_applications || cart.discount_applications.length === 0) {
      return false;
    }

    // Check if any discount is code-based (not automatic)
    return cart.discount_applications.some(discount =>
      discount.type === 'discount_code'
    );
  }

  calculateCartTotal(cart) {
    // Calculate total excluding free items (same logic as cart-free-gift-manager)
    let totalCents = 0;

    cart.items.forEach(item => {
      // Exclude items with _free_gift property (auto-gifts and free jewelry already added)
      if (!item.properties || item.properties._free_gift !== 'true') {
        totalCents += item.final_line_price;
      }
    });

    return totalCents / 100;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FreeJewelryBadgeManager();
  });
} else {
  new FreeJewelryBadgeManager();
}
